import LeadsComponent from 'components/featured/Leads';
import React from 'react';

const Leads = () => {
  return (
    <div>
      <LeadsComponent />
    </div>
  );
};

export default Leads;
